import React, { useState } from "react";
import PropTypes from "prop-types";

// Import Modal
import Modal from "react-bootstrap/Modal";

//import Alert
import { toast } from "react-toastify";

// Import service
import signNameService from "../../services/signname.service";
import authService from "../../services/auth.service";

//Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

// import moment from "moment";
// import OverwriteMomentBE from "../../components/DatePicker/OverwriteMomentBE";
// import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

function ModaladdUploadSign(props) {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  // const [selectedDate, handleSelectedDateChange] = useState(
  //   moment().add(0, "years")
  // );

  const handleClose = () => {
    initialForm();
    props.hidden(false);
  };

  const initialForm = () => {
    setForm({});
    setErrors({});
  };
  const setField = (field, value) => {
    if (field.files) {
      // console.log(field.name);
      const fileSizeKiloBytes = field.files[0].size / 1024;
      if (fileSizeKiloBytes < 15) {
        setForm({
          ...form,
          [field.name]: field.files[0],
        });
        if (errors[field.name])
          setErrors({
            ...errors,
            [field.name]: null,
          });
      } else {
        toast.error("ไม่สามารถเลือกไฟล์ขนาดมากกว่า 15 KB ได้");
      }
    } else {
      setForm({
        ...form,
        [field.name]: value,
      });
      if (errors[field.name])
        setErrors({
          ...errors,
          [field.name]: null,
        });
    }
  };
  const findFormErrors = () => {
    const { sign_name, sign_position, filename } = form;
    const newErrors = {};

    // start date errors
    if (!sign_name || sign_name === "")
      newErrors.sign_name = "กรุณากรอกชื่อและนามสกุล";
    // else if (usertype.length > 2) newErrors.usertype = "name is too long!";

    // end date errors
    if (!sign_position || sign_position === "")
      newErrors.sign_position = "กรุณากรอกตำแหน่ง";

    // end date errors
    if (!filename) newErrors.filename = "กรุณาเลือกไฟล์";

    return newErrors;
  };

  const handleSubmit = (e) => {
    // console.log(form);
    // const data = new FormData();
    // for (const key in form) {
    //   data.append(key, form[key]);
    // }
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const user = authService.getCurrentUser();
      form.user_id = user.user.user_id;
      const data = new FormData();
      for (const key in form) {
        data.append(key, form[key]);
      }
      signNameService
        .createSignname(data)
        .then((response) => {
          props.setdata([response.data, ...props.data]);
          handleClose();
          toast.success("เพิ่มลายเซนต์เรียบร้อย");
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };
  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มลายเซนต์</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อ-นาสกุล</Form.Label>
                  <FormControl
                    placeholder="ชื่อ-นาสกุล"
                    type="text"
                    name="sign_name"
                    value={form.sign_name}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.sign_name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.sign_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ตำแหน่ง</Form.Label>
                  <FormControl
                    placeholder="ตำแหน่ง"
                    type="text"
                    name="sign_position"
                    value={form.sign_position}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.sign_position}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.sign_position}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-12">
                  <Form.Label>ลายเซนต์</Form.Label>
                  <Form.Control
                    type="file"
                    label="เลือกไฟล์"
                    name="filename"
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.filename}
                    accept=".png"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.filename}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            บันทึก
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModaladdUploadSign;

ModaladdUploadSign.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.object,
  setdata: PropTypes.func,
};
